// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumbs-container__breadcrumbs--text{font-weight:700;font-size:16px;line-height:20px}.breadcrumbs-container__breadcrumbs--text:hover{text-decoration:underline}.v-breadcrumbs li:nth-child(2n){padding:0 4px}", ""]);
// Exports
module.exports = exports;
